import { render, staticRenderFns } from "./DynamicDropbox.vue?vue&type=template&id=ec99fd5c&scoped=true&"
import script from "./DynamicDropbox.vue?vue&type=script&lang=js&"
export * from "./DynamicDropbox.vue?vue&type=script&lang=js&"
import style0 from "./DynamicDropbox.vue?vue&type=style&index=0&id=ec99fd5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec99fd5c",
  null
  
)

export default component.exports